<div class="fx-column fx-flex">
    <!-- Header -->
    <div class="header">
        <h2 i18n="Switch organization|Header">Switch Organization</h2>
        <p *ngIf="!hasLimitedTenancy" i18n="Switch organization|Description">
            Choose an organization and adjust permissions as necessary.
        </p>
    </div>

    <!-- Spinner -->
    <mat-spinner style="margin: 0 auto" *ngIf="loading" [diameter]="90"></mat-spinner>

    <!-- Content -->
    <div class="content fx-column" *ngIf="!loading">
        <ng-container
            *ngIf="hasLimitedTenancy; then userTenancyAccessTemplate; else internalUserTemplate"
        ></ng-container>
    </div>

    <!-- Footer -->
    <div class="footer fx-row fx-layout-align-start-center fx-layout-gap-8">
        <div class="fx-flex"></div>
        <button mat-raised-button color="primary" (click)="cancel()" (keydown.enter)="cancel()">
            <span translate>common.buttons.cancel</span>
        </button>
        <button
            mat-raised-button
            [disabled]="loading || !selectedTenant"
            color="accent"
            (click)="ok()"
            (keydown.enter)="ok()"
        >
            OK
        </button>
    </div>
</div>

<!-- Impersonate to another organization with role selection (sysAdmin view) -->
<ng-template #internalUserTemplate>
    <!-- Select organization -->
    <ce-search-with-autocomplete
        placeholder="Organization *"
        [options$]="autocompleteTenants$"
        (optionSelected)="selectTenant($event)"
        (optionConfirmed)="ok()"
        [focusInputOnLoad]="true"
    ></ce-search-with-autocomplete>

    <!-- Select roles -->
    <ng-container *ngIf="!isOemReadonly && defaultRole; else customRoleTemplate">
        <!-- default role -->
        <p translate>
            common.dialogs.impersonate.login_with_default_privileges
            <span class="link" (click)="useCustomRole()" (keydown.enter)="useCustomRole()" translate
                >common.buttons.change</span
            >
        </p>
    </ng-container>

    <!-- custom role -->
    <!--  OemReadonly doesn't allow to change their impersonated role-->
    <ng-template #customRoleTemplate>
        <div class="fx-column fx-layout-gap-20" *ngIf="!isOemReadonly">
            <p translate>common.dialogs.impersonate.login_with_special_privileges</p>
            <!-- system roles -->
            <div class="fx-row">
                <mat-form-field floatLabel="auto" class="fx-flex">
                    <!-- system roles in practice, just named as privileges -->
                    <mat-label translate>common.dialogs.impersonate.privileges</mat-label>
                    <mat-select id="roles" [(value)]="selectedSystemRole">
                        <mat-option *ngFor="let sr of systemRolesToImpersonate" [value]="sr.id">
                            {{ sr.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <!-- tenant roles -->
            <ce-multiselect-autocomplete
                *ngIf="((tenantRoles$ | async) || [])?.length"
                [label]="'Roles created by tenant'"
                [items]="(tenantRoles$ | async) || []"
                [customerPrivacyFilter]="'randomNumber'"
                (selectedChanged)="selectedTenantRolesChanged($event)"
            ></ce-multiselect-autocomplete>
        </div>
    </ng-template>
</ng-template>

<!-- Impersonate to another organization with tenancy access -->
<ng-template #userTenancyAccessTemplate>
    <div *ngIf="hasLimitedTenancy" class="fx-column fx-layout-align-start fx-layout-gap-12">
        <mat-label translate>common.dialogs.impersonate.select_organization</mat-label>
        <mat-select [(value)]="selectedTenancyAccess" (selectionChange)="changeSelectedUserTenancyAccess($event)">
            <mat-option *ngFor="let sr of userTenancies" [value]="sr">
                {{ sr.targetTenantName }}
            </mat-option>
        </mat-select>

        <ng-container *ngIf="selectedTenancyAccess && selectedTenancyAccessPrivileges">
            <p translate>common.dialogs.impersonate.following_permissions_has_been_granted</p>
            <strong>{{ selectedTenancyAccessPrivileges }}</strong>
        </ng-container>
    </div>
</ng-template>
